import cx from 'classnames';
import type { PropsWithChildren } from 'react';

export interface FormWidthElementLayoutProps extends PropsWithChildren {
	type?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'max';
	className?: string;
}

const widthTable = {
	xs: '[115px]',
	s: '[160px]',
	m: '[270px]',
	l: '[320px]',
	xl: '[500px]',
	max: 'max',
} as const;

export const FormWidthElementLayout = ({
	children,
	className,
	type = 'm',
}: FormWidthElementLayoutProps) => (
	<div
		className={cx(
			'w-full',
			widthTable[type] && `md:max-w-${widthTable[type]}`,
			className
		)}>
		{children}
	</div>
);
